<div class="row">
  <div *ngIf="showThumbnails" class="offset-3 offset-md-2 "></div>
  <div [ngClass]="showThumbnails ? 'col-9' : 'col-md-12'">
    <ds-badges *ngIf="showLabel" [object]="dso" [context]="context"></ds-badges>
    <a *ngIf="linkType !== linkTypes.None" [target]="(linkType === linkTypes.ExternalLink) ? '_blank' : '_self'" [attr.rel]="(linkType === linkTypes.ExternalLink) ? 'noopener noreferrer' : null" [routerLink]="['/collections/' + dso.id]" class="lead" [innerHTML]="dsoTitle"></a>
    <span *ngIf="linkType === linkTypes.None" class="lead" [innerHTML]="dsoTitle"></span>
    <div *ngIf="dso.shortDescription" class="text-muted abstract-text" [innerHTML]="firstMetadataValue('dc.description.abstract')"></div>
  </div>
</div>
